module.exports = __webpack_public_path__ + "static/media/background.21a3f5e7.svg";